<template>
  <div>
    <div class="heading">
      <div class="txt">
        Flight {{flightId}}
      </div>
    </div>

    <div class="wrap-box">
      <div class="d-flex justify-space-between align-center">
        <div class="tabs d-flex">
          <div :class="['tab', {active:activeTab === 'info'}]" @click="switchTab('info')">BASIC INFORMATION</div>
          <div :class="['tab', {active:activeTab === 'trx'}]" @click="switchTab('trx')">TRANSACTION</div>
        </div>
      </div>

      <div class="info-box" v-show="activeTab === 'info'">
        <fdetails v-if="doneAllLoading" ref="fDetails"></fdetails>
      </div>

      <trx ref="trx" v-show="activeTab === 'trx'" />
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import fdetails from './details'
import trx from './trx'
import airportCodeTz from '@/data/airport-code-tz.js'

export default {
  name: 'flight-details',
  components: { fdetails, trx },
  data () {
    return {
      doneAllLoading: false,
      rsvpQueue: [],
      returnTripLoaded: false,
      activeTab: 'info'
    }
  },
  computed: {
    id () { return this.$route.params.id },
    flightDetails () { return this.$store.state.flightDetails.details },
    flightId () {
      if (!this.flightDetails.roundtripId) return this.id
      return parseInt(this.id) > this.flightDetails.roundtripId ? `${this.flightDetails.roundtripId} - ${this.id}` : `${this.id} - ${this.flightDetails.roundtripId}`
    }
  },
  methods: {
    getAirportList () {
      let self = this
      if (self.$store.state.airports.list.length > 0) {
        self.init()
        return
      }

      self.$store.commit('airports/setLoading', true)
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.get('/airports', {}, res => {
        self.$store.commit('airports/setLoading', false)
        let list = []
        res.list.forEach(function (data) {
          let add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2
          let add2 = data.addressLine2 === null ? '' : data.addressLine1
          let title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            })
          }
        })
        self.$store.commit('airports/setList', list)
        self.init()
      })
    },
    init () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.doneAllLoading = false
      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/get`, {
        token: self.$store.state.session.sessionToken,
        id: self.id,
        raw: true
      }, res => {
        if (res.error || (res.list && !res.list.length)) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.overAllLoading = false
          self.$router.push({name: 'MissingPage'})
          return
        }

        let tmp = res.list[0]
        let data = {
          bookingId: tmp.bookingId,
          bookedDate: moment(tmp.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
          airlinePNR: tmp.pnr,
          roundtripId: tmp.roundTripId,
          flights: {
            oneway: [],
            return: []
          },
          pax: [],
          airFareTotal: tmp.fareFlightTotal,
          status: tmp.status,
          isRefundable: tmp.isRefundable
        }
        let flightDetails = tmp.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.FlightDetails.Details
        flightDetails[0].forEach(f => {
          data.flights.oneway.push({
            // airlinePNR: f.AirlinePNR,
            flightName: f.OperatorName,
            flightCode: f.OperatorCode,
            flightNo: f.FlightNumber,
            duration: f.Duration,
            origin: {
              code: f.Origin.AirportCode,
              name: f.Origin.AirportName,
              date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              dateLA: self.convertToLATimezone(f.Origin)
            },
            destination: {
              code: f.Destination.AirportCode,
              name: f.Destination.AirportName,
              date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              dateLA: self.convertToLATimezone(f.Destination)
            }
          })
        })

        if (tmp.roundTripId && flightDetails[1]) {
          flightDetails[1].forEach(f => {
            data.flights.return.push({
              // airlinePNR: f.AirlinePNR,
              flightName: f.OperatorName,
              flightCode: f.OperatorCode,
              flightNo: f.FlightNumber,
              duration: f.Duration,
              origin: {
                code: f.Origin.AirportCode,
                name: f.Origin.AirportName,
                date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                dateLA: self.convertToLATimezone(f.Origin)
              },
              destination: {
                code: f.Destination.AirportCode,
                name: f.Destination.AirportName,
                date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                dateLA: self.convertToLATimezone(f.Destination)
              }
            })
          })
        }

        data.isPending = false
        if (tmp.commitData) {
          tmp.commitData.CommitBooking.BookingDetails.PassengerDetails.forEach(p => {
            data.pax.push({
              firstName: p.FirstName,
              lastName: p.LastName,
              ticketId: p.TicketId,
              ticketNo: p.TicketNumber
            })
          })
        } else {
          data.isPending = true
        }
        self.$store.commit('flightDetails/setFlightDetails', {details: data})

        let isFirstLeg = true
        if (tmp.roundTripId && tmp.id > tmp.roundTripId) isFirstLeg = false
        if (tmp.rsvpId1) {
          self.rsvpQueue.push({
            rsvp: isFirstLeg ? 'rsvp1' : 'rsvp3',
            id: tmp.rsvpId1
          })
        }
        if (tmp.rsvpId2) {
          self.rsvpQueue.push({
            rsvp: isFirstLeg ? 'rsvp2' : 'rsvp4',
            id: tmp.rsvpId2
          })
        }
        self.getRsvpData()
      })
    },
    getRsvpData () {
      let self = this
      if (!self.rsvpQueue.length || (self.rsvpQueue[0] && !self.rsvpQueue[0].id)) {
        if (self.flightDetails.roundtripId && !self.returnTripLoaded) {
          self.getReturnRSVP()
          return
        }
        self.doneAllLoading = true
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (self.activeTab === 'trx') {
          if (self.$refs.trx.getTrx()) {
            self.$refs.trx.getTrx()
          }
        }
        setTimeout(function () {
          if (self.$refs.fDetails.initMap()) {
            self.$refs.fDetails.initMap()
          }
        }, 250)
        return
      }

      self.$sdk.get(`/admin/rsvp/${self.rsvpQueue[0].id}`, {
        token: self.$store.state.session.sessionToken
      }, res => {
        if (res.error) {
          console.log('error rsvp data')
          self.rsvpQueue.shift()
          self.getRsvpData()
          return
        }
        let tmp = {}
        let total = parseFloat(res.payment.total || 0) + (res.travelInsurance || 0) + (res.gasFee || 0) + (res.airportFee || 0)
        tmp[self.rsvpQueue[0].rsvp] = {
          id: res.ID,
          service: res.serviceType.name,
          pickup: res.pickupLocation,
          dropoff: res.dropoffLocation,
          pickupDate: moment(res.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(res.pickupTimezone).format('MM/DD/YYYY hh:mmA'),
          pickupDateLA: moment(res.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
          payment: total.toFixed(2),
          status: res.status
        }
        self.$store.commit('flightDetails/setFlightDetails', tmp)
        self.rsvpQueue.shift()
        self.getRsvpData()
      })
    },
    getReturnRSVP () {
      let self = this
      // self.overAllLoading = false
      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/get`, {
        token: self.$store.state.session.sessionToken,
        id: self.flightDetails.roundtripId
      }, res => {
        if (res.error || (res.list && !res.list.length)) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.overAllLoading = false
          self.$router.push({name: 'MissingPage'})
          return
        }
        let tmp = res.list[0]
        let isFirstLeg = true
        if (tmp.roundTripId && self.flightDetails.roundtripId > tmp.roundTripId) isFirstLeg = false
        self.rsvpQueue.push({
          rsvp: isFirstLeg ? 'rsvp1' : 'rsvp3',
          id: tmp.rsvpId1
        })
        self.rsvpQueue.push({
          rsvp: isFirstLeg ? 'rsvp2' : 'rsvp4',
          id: tmp.rsvpId2
        })
        self.returnTripLoaded = true
        self.getRsvpData()
      })
    },
    switchTab (x) {
      this.activeTab = x
      if (x === 'trx' && this.$refs.trx) {
        this.$refs.trx.getTrx()
      }
    },
    convertToLATimezone (data) {
      if (airportCodeTz[data.AirportCode] && airportCodeTz[data.AirportCode] === 'America/Los_Angeles') return moment(data.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
      
      if (airportCodeTz[data.AirportCode]) {
        let tmpDate = moment.tz(data.DateTime, 'YYYY-MM-DD HH:mm', airportCodeTz[data.AirportCode])
        return tmpDate.tz('America/Los_Angeles').format('MM/DD/YYYY hh:mmA')
      }
      return 'AIRPORT tz not found'
      // return moment(data.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
    }
  },
  watch: {
    id () {
      this.doneAllLoading = false
      this.rsvpQueue = []
      this.returnTripLoaded = false
      this.$store.commit('flightDetails/setFlightDetails', {details: {}})
      this.$nextTick(() => { this.init() })
    }
  },
  mounted () {
    this.getAirportList()
  }
}
</script>

<style lang="scss" scoped>
.heading{
  height: 50px;
  padding-left: 50px;

  .txt{
    line-height: 50px;
    padding-left: 20px;
    font-size: 21px;
    font-weight: 600;
  }
}
.wrap-box{
  width: 100%;
}
.tabs{
  padding: 10px;

  .tab{
    margin-right: 20px;
    font-weight: 600;
    padding-bottom: 5px;
    color: #777;
    cursor: pointer;
  }
  .active{
    color: #0D79F2;
    border-bottom: 2px solid #0D79F2;
  }
}
.info-box{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/FlightDetails/index.vue